import { Config } from '../../types/config/config';

export const isMiqSyncEnabled = (config: Config | undefined): boolean =>
    !!(config && config.featureFlags && config.featureFlags.miqSyncEnabled === true);